<template>
  <div>
    <a-modal
      centered
      :maskClosable="maskClosable"
      :title="title"
      v-model="visible"
      @ok="handleOk"
      @cancel="onClose"
      width="40%"
      okText="确认"
    >
      <div style="height: calc(100vh - 250px);overflow:hidden">
        <a-input-search
          style="margin-bottom: 8px;width: 45%;"
          placeholder="关键字"
          @change="onChange"
        />
        <a-button style="margin-left:10px" type="primary" @click="selectAll"
          >全选</a-button
        >
        <a-button
          style="margin-left:10px"
          type="primary"
          @click="cancleSelectAll"
          >取消全选</a-button
        >
        <a-tree
          style="overflow:auto;height:calc(100% - 50px)"
          checkable
          @expand="onExpand"
          :expandedKeys="expandedKeys"
          :autoExpandParent="autoExpandParent"
          v-model="checkedKeys"
          @select="onSelect"
          :selectedKeys="selectedKeys"
          :treeData="treeData"
          @check="onCheck"
        >
          <template slot="title" slot-scope="{ title }">
            <span v-if="title.indexOf(searchValue) > -1">
              {{ title.substr(0, title.indexOf(searchValue)) }}
              <span style="color: #f50">{{ searchValue }}</span>
              {{
                title.substr(title.indexOf(searchValue) + searchValue.length)
              }}
            </span>
            <span v-else>{{ title }}</span>
          </template>
        </a-tree>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: "checkBoxTree",
  components: {},
  props: {
    option: {
      type: Object,
      default() {
        return {};
      }
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maskClosable: false,
      dataList: [], //记录所有节点
      searchValue: "", //当前搜索的值
      expandedKeys: [], //当前展开的节点
      autoExpandParent: true, //是否自动展开父节点
      checkedKeys: [], //当前选择的节点（只记录选中的）
      checkedContainParentKeys: [], //记录当前选择节点及包含父节点(选中子节点但父节点没有选中的)
      selectedKeys: [], //当前选择的树节点
      treeData: [
        // {
        //   title: "0-0",
        //   key: "0-0",
        //   children: [
        //     {
        //       title: "0-0-0",
        //       key: "0-0-0",
        //       children: [
        //         { title: "0-0-0-0", key: "0-0-0-0" },
        //         { title: "0-0-0-1", key: "0-0-0-1" },
        //         { title: "0-0-0-2", key: "0-0-0-2" }
        //       ]
        //     },
        //     {
        //       title: "0-0-1",
        //       key: "0-0-1",
        //       children: [
        //         { title: "0-0-1-0", key: "0-0-1-0" },
        //         { title: "0-0-1-1", key: "0-0-1-1" },
        //         { title: "0-0-1-2", key: "0-0-1-2" }
        //       ]
        //     },
        //     {
        //       title: "0-0-2",
        //       key: "0-0-2"
        //     }
        //   ]
        // },
        // {
        //   title: "0-1",
        //   key: "0-1",
        //   children: [
        //     {
        //       title: "0-1-0-3",
        //       key: "0-1-0-3",
        //       scopedSlots: { title: "title" }
        //     },
        //     { title: "0-1-0-1", key: "0-1-0-1" },
        //     { title: "0-1-0-2", key: "0-1-0-2" }
        //   ]
        // },
        // {
        //   title: "0-2",
        //   key: "0-2"
        // }
      ]
    };
  },
  created() {},
  mounted() {},
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    onChange(e) {
      const value = e.target.value;
      if (!value) {
        this.searchValue = "";
        return false;
      }
      const expandedKeys = this.dataList
        .map(item => {
          if (item.title.indexOf(value) > -1) {
            return this.getParentKey(item.key, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      });
    },
    generateList(data) {
      for (let i = 0; i < data.length; i++) {
        const node = data[i];
        const key = node.key;
        this.dataList.push({ key, title: node.title });
        if (node.children) {
          this.generateList(node.children, node.key);
        }
      }
    },
    getParentKey(key, tree) {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    //默认展开的节点
    onExpandkeys(data) {
      data.forEach(item => {
        this.expandedKeys.push(item.key);
      });
    },
    //记录当前展开的节点
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    //记录当前选中的节点
    onCheck(checkedKeys, info) {
      this.checkedKeys = checkedKeys;
      this.checkedContainParentKeys = info.halfCheckedKeys;
      if (this.checkedKeys && this.checkedKeys.length > 0)
        this.checkedKeys.forEach(item => {
          this.checkedContainParentKeys.push(item);
        });
    },
    //选择的树节点
    onSelect(/*selectedKeys*/) {
      //this.selectedKeys = selectedKeys;
    },
    selectAll() {
      this.checkedKeys = [];
      this.checkedContainParentKeys = [];
      this.dataList.forEach(item => {
        this.checkedKeys.push(item.key);
        this.checkedContainParentKeys.push(item.key);
      });
    },
    cancleSelectAll() {
      this.checkedKeys = [];
      this.checkedContainParentKeys = [];
    },
    //根据后台返回数据 生成树，并记录已选择的节点
    onGenerateList(data, title, children, key /*, parentNode*/) {
      this.buildTree(data, title, children, key, false);
      return data;
    },
    buildTree(orginTree, title, children, key, parentNode) {
      var _this = this;
      for (let i = 0; i < orginTree.length; i++) {
        var orginTree_i = orginTree[i];
        var changeTitle = orginTree_i[title];
        var changeKey = orginTree_i[key];
        orginTree[i].title = changeTitle;
        orginTree[i].key = changeKey;
        orginTree[i].scopedSlots = { title: "title" };
        if (orginTree[i].Checked) this.checkedKeys.push(orginTree[i].key);
        var changeChildren = orginTree_i[children];
        if (changeChildren != undefined) {
          if (parentNode == true) {
            //父节点是否可选
            orginTree[i].selectable = false;
          }
          orginTree[i].children = changeChildren;
          _this.buildTree(orginTree[i][children], title, children, key, false);
        }
      }
    },
    handleOk() {
      if (
        !this.checkedContainParentKeys ||
        this.checkedContainParentKeys.length <= 0
      ) {
        if (!this.checkedKeys || this.checkedKeys.length <= 0) {
          this.$message.info("提交失败！至少勾选一项！");
        } else {
          this.$message.success("操作成功！");
          this.onClose();
        }
        return;
      }
      this.$emit(
        "submit",
        this.type,
        this.treeData,
        this.checkedContainParentKeys
      );
    },
    onClose() {
      this.$emit("close");
    }
  },
  filter: {},
  // 计算属性
  computed: {},
  watch: {
    visible() {
      const _this = this;
      if (_this.visible) {
        _this.searchValue = ""; //当前搜索的值
        _this.expandedKeys = []; //当前展开的节点
        _this.autoExpandParent = true; //是否自动展开父节点
        _this.checkedKeys = []; //当前选择的节点（只记录选中的）
        _this.checkedContainParentKeys = []; //记录当前选择节点及包含父节点(选中子节点但父节点没有选中的)
        _this.selectedKeys = []; //当前选择的树节点
        _this.treeData = [];
        _this.dataList = [];
        if (_this.option && _this.option.api) {
          const json = {};
          if (_this.option.id) json.Id = _this.option.id;
          _this.$post(_this.option.api, json).then(res => {
            if (res.Data && res.Data.length > 0) {
              let arr = _this.onGenerateList(
                res.Data,
                _this.option.textField ? _this.option.textField : "Name",
                _this.option.children ? _this.option.children : "children",
                _this.option.valueField ? _this.option.valueField : "Id",
                _this.option.parentNode ? _this.option.parentNode : "false"
              );
              _this.treeData = arr;
              //生成查询list
              _this.generateList(_this.treeData);
              //默认展开的节点
              -this.onExpandkeys(_this.treeData);
            } else {
              _this.$message.info("无返回数据！");
            }
          });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped></style>
